<div class="billing-portal-container container card">
	<p-toast></p-toast>

	<div id="mention_table">
		<div class="tyalls-table-name mb-3 flex">
			<h6 class="tyalls-table-heading">
				Billing Portal
				<span class="font-light">
          - {{ currentProperty?.name }}
        </span>
			</h6>
		</div>
	</div>

	<p class="text-gray-700 mb-4">
		Securely manage your billing details, update your contacts and billing
		address, and review your invoice history for this property.
	</p>

	<!-- LOADING -->
	<ng-container *ngIf="loading; else loadedTpl">
		<div class="flex justify-content-center p-5">
			<p-progressSpinner styleClass="w-3rem h-3rem"></p-progressSpinner>
		</div>
	</ng-container>

	<ng-template #loadedTpl>
		<!-- NO CONTACT YET -->
		<ng-container *ngIf="!contact; else contactTpl">
			<div class="text-center py-6">
				<h5 class="text-xl font-semibold mb-2">No billing details yet</h5>
				<p class="text-gray-700 mb-3">
					This property doesn’t have billing set up. Please complete the Billing
					Setup first.
				</p>
			</div>
		</ng-container>

		<!-- CONTACT EXISTS -->
		<ng-template #contactTpl>
			<p-tabView>
				<!-- TAB 1 -->
				<p-tabPanel header="Billing Details" headerStyleClass="p-1">
					<app-billing-details
						[contact]="contact"
						[saving]="saving"
						(save)="onSaveContact($event)"
					></app-billing-details>
				</p-tabPanel>

				<!-- TAB 2 -->
				<p-tabPanel header="Billing History" headerStyleClass="p-1">
					<app-billing-history
						[invoices]="invoices"
						(download)="onDownloadInvoice($event.invoice, $event.download)"
					></app-billing-history>
				</p-tabPanel>

				<!-- TAB 3: YOUR PLAN -->
				<p-tabPanel header="Your Plan" headerStyleClass="p-1">
					<app-billing-current-plan [plan]="pricingTier"></app-billing-current-plan>
				</p-tabPanel>

			</p-tabView>
		</ng-template>
	</ng-template>
</div>
